import { transformErrorResponse } from "../../transformErrorResponse"
import { TOAOrdenLiquidacionENTITY } from "sigo-entities"
import { AtcApiBuilder } from "."

export const PERU_9112_TOAOrderPreliquidacion = (build: AtcApiBuilder) => {
    return {
        getByIdTOAOrders: build.query<TOAOrdenLiquidacionENTITY[], string>({
            query: (userId) => `procesos/peru_9112_toaorderpreliquidacion/${userId}`,
            providesTags: (result, error, userId) =>
                result
                    ? [
                        // tag individual por cada orden
                        ...result.map((order) => ({
                            type: 'TOAOrders' as const,
                            id: order._id,
                        })),
                        // y un tag general de la lista de ese usuario
                        { type: 'TOAOrders' as const, id: `USER-${userId}` },
                    ]
                    : [{ type: 'TOAOrders' as const, id: `USER-${userId}` }],
            transformErrorResponse
        }),
        getTransitTOAOrders: build.query<{ transito: number }, { id_recurso: string, codigo: string }>({
            query: ({ id_recurso, codigo }) => `procesos/peru_9112_toaorderpreliquidacion/calculate-transit/${id_recurso}/${codigo}`,
            transformErrorResponse
        }),
        addInventoryTOAOrders: build.mutation<TOAOrdenLiquidacionENTITY, { id: string, body: { ID_StockPersonal: number, cantidad: number } }>({
            query: ({ body, id }) => ({
                url: `procesos/peru_9112_toaorderpreliquidacion/add-inventory/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'TOAOrders' as const, id },
            ],
            transformErrorResponse
        }),
        deleteInventoryTOAOrders: build.mutation<TOAOrdenLiquidacionENTITY, { id: string, codigo: number, serie: string }>({
            query: ({ id, codigo, serie }) => ({
                url: `procesos/peru_9112_toaorderpreliquidacion/delete-inventory/${id}/${codigo}?serie=${serie}`,
                method: "PUT",
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'TOAOrders' as const, id },
            ],
            transformErrorResponse
        }),
        sendReviewTOAOrders: build.mutation<TOAOrdenLiquidacionENTITY, { id: string }>({
            query: ({ id }) => ({
                url: `procesos/peru_9112_toaorderpreliquidacion/send-review/${id}`,
                method: "PUT"
            }),
            invalidatesTags: (result, error, { id }) => [
                // invalida la orden puntual
                { type: 'TOAOrders' as const, id },
                // y también la lista del usuario (para que se refresque)
                // { type: 'TOAOrders' as const, id: `USER-${userId}` },
            ],
            transformErrorResponse
        })
    }
}